/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const LoadingWrapper = styled.div({
  alignItems: 'center',
  display: 'flex',
  height: '60vh',
  justifyContent: 'center',
});

export const ErrorStateWrapper = styled.div({
  alignItems: 'center',
  display: 'flex',
  height: '60vh',
  justifyContent: 'center',
});

export const PageTitleWrapper = styled.div({
  alignItems: 'center',
  display: 'flex',
});

export const LozengeWrapper = styled.div({
  marginLeft: `${gridSize()}px`,
  /* needs this to vertically center the lozenge */
  marginBottom: `-${gridSize() / 4}px`,
  display: 'flex',
  alignItems: 'center',
});

export const PageHeaderActionsWrapper = styled.div({
  display: 'inline-flex',
});

export const PageHeaderActionItem = styled.div({
  marginLeft: `${gridSize()}px`,
});
